import { union } from '../dependencies';

export function bucketTotalTagsReducer(totalBucket) {
    const allTagIds = totalBucket.tagsDistribution.reduce((acc, item) => acc.concat(item.tagIds), []);

    return union(allTagIds).map(String);
}
